module.exports = __webpack_public_path__ + "img/cursor-click-02.7c7104aa.svg";